import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Route, Switch, Link} from 'react-router-dom';
import Main from './Main';
import Event from './Event';
import Nmi from './Nmi';
import View from './View';
import SelfValidate from './SelfValidate';

export default class App extends Component {
  render() {
    return (
      <div>
        <Router>
          <Switch>
            <Route path="/" exact strict component={() => <Main />}/>
            <Route path="/nmi" exact strict component={() => <Nmi />}/>
            <Route path="/event" exact strict component={() => <Event />}/>
            <Route path="/self-validate" exact strict component={() => <SelfValidate />}/>
            <Route path="/view" exact strict component={() => <View />}/>
          </Switch>
        </Router>
      </div>
    )
  }
}
